import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

export const useDefaultDistance = (queryParamDistance?: number | string) => {
    const queryDistance = Boolean(queryParamDistance);
    const formValuesFromQuery = useSelector((state: IRPStore) => state.search.formValues);
    const [distance, setDistance] = useState(queryParamDistance ? +queryParamDistance : formValuesFromQuery.distance);

    useEffect(() => {
        if (queryDistance) {
            setDistance(queryParamDistance);
            return;
        }

        if (formValuesFromQuery && formValuesFromQuery.distance) {
            setDistance(formValuesFromQuery.distance);
        }
    }, [queryParamDistance]);

    return distance;
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";

export const useDefaultDistance = (queryParamDistance?: number | string) => {
    const queryDistance = Boolean(queryParamDistance);
    const formValuesFromQuery = useSelector((state: IRPStore) => state.search.formValues);
    const [distance, setDistance] = useState(queryParamDistance ? +queryParamDistance : formValuesFromQuery.distance);

    useEffect(() => {
        if (queryDistance) {
            setDistance(queryParamDistance);
            return;
        }

        if (formValuesFromQuery && formValuesFromQuery.distance) {
            setDistance(formValuesFromQuery.distance);
        }
    }, [queryParamDistance]);

    return distance;
};
